export default __webpack_public_path__ + "static/media/financial-info-2.01eaa432.png";